import {ColorScheme} from '~/src/utilities/constants/formats';

export interface StyleFormat {
    primaryGrid: string;
    secondaryGrid: string;
    colorScheme: string;
}

const createFormat = (primaryGrid: string, secondaryGrid?: string, colorScheme?: string): StyleFormat => {
    secondaryGrid = secondaryGrid || primaryGrid;
    colorScheme = colorScheme || ColorScheme.PRIMARY;
    return {primaryGrid, secondaryGrid, colorScheme};
};

export {createFormat};
